<template>
  <button
    class="vi-button"
    :class="{'isSmall':isSmall,'isOutlined':isOutlined}"
    :type="type"
    :disabled="isDisabled"
    @click="$ev => $emit('click', $ev)">
    <span class="button-label" :class="{'hide-button-label':isLoading}">{{ buttonLabel }}</span>
    <span v-if="isLoading" class="button-loading-animation"></span>
  </button>
</template>
<script>
export default {
  name: "ViButton",
  props: {
    buttonLabel: {
      type: String,
      required: true
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'button'
    },
    isSmall: Boolean,
    isOutlined: Boolean,
  },
}
</script>

<style lang="scss">
@import "ViButton";
</style>
